import React, { useRef } from "react";
import DOMPurify from "dompurify";
import { Editor } from "@tinymce/tinymce-react";

type Props = {
  id?: string;
  content?: any;
  setConvertedContent?: any;
};

const TextEditor: React.FC<Props> = ({
  id,
  content,
  setConvertedContent,
}): JSX.Element => {
  const editorRef = useRef<any>(null);

  const createMarkup = (html: any) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };

  return (
    <div className="flex flex-col mt-7">
      <span
        className="text-sm"
        style={{
          fontStyle: "normal",
          fontWeight: 400,
          color: "#000000",
        }}
      >
        Text
      </span>
      {id && content ? (
        <div
          className="flex flex-row mt-5"
          style={{
            boxSizing: "border-box",
            background: "#F5F5F5",
            border: "0.5px solid #8E8E8E",
            borderRadius: "4px",
          }}
        >
          <div
            className="my-6 mx-5 text-base"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#4F4F4F",
            }}
          >
            <div dangerouslySetInnerHTML={createMarkup(content)} />
          </div>
        </div>
      ) : (
        <Editor
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={content}
          onEditorChange={(content: any) => {
            setConvertedContent(content);
          }}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
            ],
            toolbar:
              "undo redo | formatselect | " +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      )}
    </div>
  );
};

export default TextEditor;
